(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1983],{

/***/ 19668:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kishalaya",
      function () {
        return __webpack_require__(34345);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_kishalaya; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/layout/layout.tsx + 26 modules
var layout = __webpack_require__(26419);
;// CONCATENATED MODULE: ./src/assets/images/kishalaya.jpg
/* harmony default export */ var kishalaya = ({"src":"/_next/static/media/kishalaya.62c02dad.jpg","height":400,"width":1263,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAbEAEAAgIDAAAAAAAAAAAAAAABAAMCBBEhMf/EABQBAQAAAAAAAAAAAAAAAAAAAAL/xAAXEQEAAwAAAAAAAAAAAAAAAAAAARJR/9oADAMBAAIRAxEAPwCYw3NgrxqLOMSt6APBiIgrGG//2Q=="});
// EXTERNAL MODULE: ./src/styles/kishalaya.module.scss
var kishalaya_module = __webpack_require__(77645);
var kishalaya_module_default = /*#__PURE__*/__webpack_require__.n(kishalaya_module);
;// CONCATENATED MODULE: ./src/pages/kishalaya.tsx



swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Autoplay */.pt
]);




var Kishalaya = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (kishalaya_module_default()).csr_banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: kishalaya,
                    alt: "",
                    width: 2313,
                    height: 923
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (kishalaya_module_default()).table,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "table-responsive",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                className: "mt-5 table table-bordered",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                colSpan: 4,
                                                className: (kishalaya_module_default()).tab_h,
                                                children: "PROJECT-KISHALAYA"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                colSpan: 4,
                                                className: "text-center",
                                                children: "SENCO GOLD AND DIAMONDS CSR INITIATIVES FOR EDUCATIONAL SUPPORT TO UNDERPRIVILEGED STUDENTS(PRIMARY LEVEL)"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                colSpan: 4,
                                                className: "text-center",
                                                children: "EXECUTED BY P C SEN CHARITABLE TRUST"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "PROJECT INSIGHT"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    colSpan: 4,
                                                    children: "Our humble support to underprivileged students in pursuing their basic education, either by extending one time or monthly financial support, or by donating educational kits and support system"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "DURATION"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    colSpan: 4,
                                                    children: "(2023-24, 2024-25, 2025-26)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "PROJECT"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    colSpan: 4,
                                                    children: "SARADA-NIVEDITA VIDYATAN & PRABHAT-SHANKAR SHISHU UDYAN, in association with Alinan Ramakrishna Vivekananda Yuva Sangha, Alinan, Purba Medinipur"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: (kishalaya_module_default()).tab_h,
                                                colSpan: 4,
                                                children: "PROJECT IMPLEMENTATION PLAN"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "SL NO"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "YEAR"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "LOCATION"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "Project Details"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "2023-24"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Mayachar Island, Mahishadal Block, Purba Medinipur"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Reconstruction of Creche-cum-Pre-Primary Education Centre"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Construction of Prabhat-Shaankar Shishu Udyan, play area of the students of the creche-cum-Pre-Primary Education, just opposite to the Centre."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Power Breakfast and educational kits and Medical Camp (to be continued in the next financial year)"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                colSpan: 4,
                                                className: (kishalaya_module_default()).tab_h,
                                                children: "ONGOING PROJECTS"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "SL NO"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "YEAR"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "LOCATION"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "Project Details"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "2023-24"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Anandaa Nagar Development Society, Purulia"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Support to hostel underprivileged students pursuing school and college education under the society"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "2"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Alinan, Purba Medinipur"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Udbadhan Primary School"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "3"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Vivekananda School & Skill Development Centre, Bamon Mollarchawk, South 24 Parganas"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "One time support in Educational Kits etc"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "4"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Shivmandir Seva Pratisthan, Kolkata"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "One time support in Educational Kits etc to an evening school run by Shivmandir Seva Pratisthan"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var pages_kishalaya = (Kishalaya);


/***/ }),

/***/ 77645:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab_h":"kishalaya_tab_h__Q0wbr","table":"kishalaya_table__Xvlyg","w_50":"kishalaya_w_50__9z9Xj"};

/***/ }),

/***/ 5607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Collapse.js + 1 modules
var Collapse = __webpack_require__(16518);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionContext.js

function isAccordionItemSelected(activeEventKey, eventKey) {
  return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const context = /*#__PURE__*/react.createContext({});
context.displayName = 'AccordionContext';
/* harmony default export */ var AccordionContext = (context);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionCollapse.js








/**
 * This component accepts all of [`Collapse`'s props](/utilities/transitions/#collapse-props).
 */
const AccordionCollapse = /*#__PURE__*/react.forwardRef(({
  as: Component = 'div',
  bsPrefix,
  className,
  children,
  eventKey,
  ...props
}, ref) => {
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-collapse');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
    ref: ref,
    in: isAccordionItemSelected(activeEventKey, eventKey),
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      children: react.Children.only(children)
    })
  });
});
AccordionCollapse.displayName = 'AccordionCollapse';
/* harmony default export */ var esm_AccordionCollapse = (AccordionCollapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItemContext.js

const AccordionItemContext_context = /*#__PURE__*/react.createContext({
  eventKey: ''
});
AccordionItemContext_context.displayName = 'AccordionItemContext';
/* harmony default export */ var AccordionItemContext = (AccordionItemContext_context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionBody.js







const AccordionBody = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-body');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionCollapse, {
    eventKey: eventKey,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionBody.displayName = 'AccordionBody';
/* harmony default export */ var esm_AccordionBody = (AccordionBody);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionButton.js







function useAccordionButton(eventKey, onClick) {
  const {
    activeEventKey,
    onSelect,
    alwaysOpen
  } = (0,react.useContext)(AccordionContext);
  return e => {
    /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */
    let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;

    if (alwaysOpen) {
      if (Array.isArray(activeEventKey)) {
        if (activeEventKey.includes(eventKey)) {
          eventKeyPassed = activeEventKey.filter(k => k !== eventKey);
        } else {
          eventKeyPassed = [...activeEventKey, eventKey];
        }
      } else {
        // activeEventKey is undefined.
        eventKeyPassed = [eventKey];
      }
    }

    onSelect == null ? void 0 : onSelect(eventKeyPassed, e);
    onClick == null ? void 0 : onClick(e);
  };
}
const AccordionButton = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'button',
  bsPrefix,
  className,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-button');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  const accordionOnClick = useAccordionButton(eventKey, onClick);
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);

  if (Component === 'button') {
    props.type = 'button';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    onClick: accordionOnClick,
    ...props,
    "aria-expanded": eventKey === activeEventKey,
    className: classnames_default()(className, bsPrefix, !isAccordionItemSelected(activeEventKey, eventKey) && 'collapsed')
  });
});
AccordionButton.displayName = 'AccordionButton';
/* harmony default export */ var esm_AccordionButton = (AccordionButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionHeader.js





const AccordionHeader = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'h2',
  bsPrefix,
  className,
  children,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionButton, {
      onClick: onClick,
      children: children
    })
  });
});
AccordionHeader.displayName = 'AccordionHeader';
/* harmony default export */ var esm_AccordionHeader = (AccordionHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItem.js






const AccordionItem = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-item');
  const contextValue = (0,react.useMemo)(() => ({
    eventKey
  }), [eventKey]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionItemContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionItem.displayName = 'AccordionItem';
/* harmony default export */ var esm_AccordionItem = (AccordionItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Accordion.js












const Accordion = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    activeKey,
    bsPrefix,
    className,
    onSelect,
    flush,
    alwaysOpen,
    ...controlledProps
  } = (0,esm/* useUncontrolled */.Ch)(props, {
    activeKey: 'onSelect'
  });
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion');
  const contextValue = (0,react.useMemo)(() => ({
    activeEventKey: activeKey,
    onSelect,
    alwaysOpen
  }), [activeKey, onSelect, alwaysOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...controlledProps,
      className: classnames_default()(className, prefix, flush && `${prefix}-flush`)
    })
  });
});
Accordion.displayName = 'Accordion';
/* harmony default export */ var esm_Accordion = (Object.assign(Accordion, {
  Button: esm_AccordionButton,
  Collapse: esm_AccordionCollapse,
  Item: esm_AccordionItem,
  Header: esm_AccordionHeader,
  Body: esm_AccordionBody
}));

/***/ }),

/***/ 27977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const defaultProps = {
  bg: 'primary',
  pill: false
};
const Badge = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  bg,
  pill,
  text,
  className,
  as: Component = 'span',
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'badge');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
  });
});
Badge.displayName = 'Badge';
Badge.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Badge);

/***/ }),

/***/ 55111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Marquee */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Animation = function (_a) {
    var axis = _a.axis, reverse = _a.reverse, offset = _a.offset, id = _a.id;
    return (jsx("style", { children: "\n        @keyframes m" + id + "slide" + offset + " {\n          from {\n            transform: translate" + (axis || "X") + "(" + offset * 100 + "%);\n          }\n          to {\n            transform: translate" + (axis || "X") + "(" + ((reverse ? -100 : 100) + 100 * offset) + "%);\n          }\n        }\n\n        @-webkit-keyframes m" + id + "slide" + offset + " {\n          from {\n            transform: translate" + (axis || "X") + "(" + offset * 100 + "%);\n          }\n          to {\n            transform: translate" + (axis || "X") + "(" + ((reverse ? -100 : 100) + 100 * offset) + "%);\n          }\n        }\n\n        @media (prefers-reduced-motion) {\n            animation: none;\n            -webkit-animation: none;\n        }\n      " }, void 0));
};

var marqueeCounter = 0;
var Marquee = function (_a) {
    var axis = _a.axis, reverse = _a.reverse, align = _a.align, background = _a.background, duration = _a.duration, height = _a.height, pauseOnHover = _a.pauseOnHover, width = _a.width, className = _a.className, children = _a.children;
    var _b = useState("running"), animate = _b[0], setAnimate = _b[1];
    var _c = useState(0), id = _c[0], setId = _c[1];
    useEffect(function () {
        setId(marqueeCounter);
        marqueeCounter++;
    }, []);
    var offsetValues = [-1, 0, 1];
    return (jsx("div", __assign({ className: className, onMouseEnter: function () { return pauseOnHover && setAnimate("paused"); }, onMouseLeave: function () { return pauseOnHover && setAnimate("running"); }, style: {
            display: "flex",
            overflow: "hidden",
            alignItems: "center",
            position: "relative",
            backgroundColor: background !== null && background !== void 0 ? background : "transparent",
            height: height !== null && height !== void 0 ? height : "5rem",
            width: width !== null && width !== void 0 ? width : "100%",
        } }, { children: offsetValues.map(function (offset) { return (jsxs("span", __assign({ style: {
                display: "inline-block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                position: "absolute",
                animation: "m" + id + "slide" + offset + " " + (duration !== null && duration !== void 0 ? duration : 5000) + "ms linear infinite",
                animationPlayState: animate !== null && animate !== void 0 ? animate : "running",
                minWidth: "100%",
            } }, { children: [jsx(Animation, { reverse: reverse, offset: offset, axis: axis, id: id }, void 0),
                jsx("div", __assign({ style: {
                        width: "100%",
                        height: "100%",
                        whiteSpace: "nowrap",
                        display: "flex",
                        overflow: "hidden",
                        justifyContent: "space-around",
                        flexDirection: axis === "X"
                            ? reverse
                                ? "row-reverse"
                                : "row"
                            : axis === "Y"
                                ? reverse
                                    ? "column-reverse"
                                    : "column"
                                : "row",
                        alignItems: align === "center" ? "center" : "flex-" + align,
                    } }, { children: children }), void 0)] }), offset)); }) }), void 0));
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Marquee)));

//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,959,6067,3564,1825,9774,2888,179], function() { return __webpack_exec__(19668); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);